<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Hình thức</th>
          <th scope="col">Kết quả</th>
          <th scope="col">Thời gian</th>
          <th scope="col">Ghi chú</th>
          <th scope="col">Hình ảnh</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="list.length">
          <tr v-for="(item, index) in list" :key="index">
            <td>
              {{ getAction(item.historyAction) }}
            </td>
            <td>
              {{ getResult(item.historyResult) }}
            </td>
            <td>
              {{ item.historyCreatedAt | formatDate('HH:mm DD/MM/YYYY') }}
            </td>
            <td>
              {{ item.historyNote }}
            </td>
            <td style="max-width: 293px;">
              <ul class="m-0 p-0 gap-1" v-viewer>
                <li
                  v-for="(item, index) in item.actionImgs"
                  :key="index"
                >
                  <a href="javascript:void(0)">
                    <img :src="item" />
                  </a>
                </li>
              </ul>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="5">
              <div class="text-center text-muted">
                {{ isLoading ? 'Đã lấy dữ liệu...' : 'Không có dữ liệu' }}
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <VueLoadingOverlay :active.sync="isLoading">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import { MerchantService } from '@/services/merchant.service'

const mapActions = {
  CALLED: 'Đã gọi điện',
  SENT_MESS: 'Đã nhắn tin',
  SENT_MAIL: 'Đã gửi mail',
  MET: 'Đã gặp mặt tư vấn',
  OTHER: 'Việc khác'
}

const mapResults = {
  MEET_FAIL: 'Không liên hệ được',
  NO_CARE: 'Chưa quan tâm',
  SUITABLE: 'Phù hợp',
  HAS_SERVICE: 'Đã sử dụng dịch vụ',
  WRONG: 'Thông tin sai',
  DUPLICATE: 'Trùng thông tin',
  OTHER: 'Khác'
}

export default {
  name: 'HistoryComponent',
  props: {
    id: String
  },

  components: {
    //
  },

  computed: {
    getAction () {
      return (action) => {
        return mapActions[action] || action
      }
    },
    getResult () {
      return (result) => {
        return mapResults[result] || result
      }
    }
  },

  data () {
    return {
      isLoading: false,
      list: []
    }
  },

  async mounted () {
    await this.loadData()
  },

  methods: {
    async loadData () {
      try {
        this.isLoading = true
        const res = await MerchantService.history(this.id)
        if (res.success) {
          this.list = res.data
          console.log(res.data)
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .table {
    thead {
      tr {
        background: #DDD;
        border: 1px solid #CCC;
        th {
          font-weight: 600;
          color: #0b62ab;
          border-left: 1px solid #CCC;
          &:first-child {
            border-left: none;
          }
        }
      }
    }
    tbody {
      tr {
        td {
          ul {
            padding-left: 0;
            li {
              display: inline-block;
              border: 1px solid #DDD;
              width: 80px;
              height: 60px;
              overflow-y: hidden;
              a {
                img {
                  width: 80px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
